import { render, staticRenderFns } from "./LabelRowItem.vue?vue&type=template&id=ae4efed0&scoped=true&"
import script from "./LabelRowItem.vue?vue&type=script&lang=js&"
export * from "./LabelRowItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae4efed0",
  null
  
)

export default component.exports